var map = {
	"./candy": 24,
	"./candy.json": 24,
	"./caveWall": 25,
	"./caveWall.json": 25,
	"./cloud": 26,
	"./cloud.json": 26,
	"./explosion": 27,
	"./explosion.json": 27,
	"./galaxy": 28,
	"./galaxy.json": 28,
	"./grass": 29,
	"./grass.json": 29,
	"./islands": 30,
	"./islands.json": 30,
	"./moss": 31,
	"./moss.json": 31,
	"./presetsData": 4,
	"./presetsData.json": 4,
	"./singleIsland": 32,
	"./singleIsland.json": 32,
	"./starrySky": 33,
	"./starrySky.json": 33
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;